import {Component, Input, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'li3-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: ['./global-spinner.component.scss'],
  animations: [
    trigger(
      'spinnerDisplayAnimation',
      [
        transition(
          ':enter', [
            style({opacity: 0}),
            animate('100ms', style({'opacity': 1}))
          ]
        ),
        transition(
          ':leave', [
            style({'opacity': 1}),
            animate('100ms', style({'opacity': 0}))
          ]
        )
      ]
    ),
    trigger(
      'spinnerBgdDisplayAnimation',
      [
        transition(
          ':leave', [
            style({'opacity': 0.6}),
            animate('100ms', style({'opacity': 0}))
          ]
        )
      ]
    )
  ]
})
export class GlobalSpinnerComponent implements OnInit {
  @Input() isSpinnerShown: boolean;
  @Input() isSpinnerBgdShown: boolean;

  constructor() {
  }

  ngOnInit() {
  }

}
